import { withRetry } from '../utils/retry.js';

export class AccessLogsService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        const response = await withRetry(() => this.api.getAll(params), { maxRetries: 2 });
        return {
            success: true,
            data: response.data,
            pagination: response.pagination || {},
            message: response.message || 'Access logs loaded'
        };
    }
}
